import React from "react";

const Footer = () => {
  return (
    <div className="footer container">
      <div className="footer-section">
        <p className="title">FoodiesHub.com</p>
        <p>
          FoodiesHub is a place where you can please your soul and tummy with
          delicious food recipes of all cusine. And our service is absolutely
          free.
        </p>
        <p>&copy; 2022 | All Rights Reserved</p>
      </div>
      <div className="footer-section">
        <p className="title">Contact Us</p>
        <p>Foodieshub@gmail.com</p>
        <p>+234-70129-46761</p>
        <p>192 Goldie Street Calabar NG</p>
      </div>
      <div className="footer-section">
        <p className="title">Socials</p>
        <p>Facebook</p>
        <p>Twitter</p>
        <p>Instagram</p>
      </div>
    </div>
  );
};

export default Footer;
